module.exports = __webpack_public_path__ + "img/bj_xia_zi@2x.1ff00b27.png";